import { useEffect, useState } from 'react'
import { useLocation, useNavigate, NavLink } from 'react-router-dom'
import '@/style/common/header.scss'
import logoLight from '@/images/home/logo_name_white.png'
import logoDark from '@/images/home/logo_name.png'

const MENU = [
  { text: '首页', href: '/home' },
  { text: '关于我们', href: '/intro' },
  { text: '产品', href: '/industry' },
  { text: '体系认证', href: '/systemCert' },
  { text: '合作案例', href: '/cooperationCase' },
  { text: '新闻中心', href: '/news' },
  { text: '联系我们', href: '/contact' },
]

// 这些路由首屏是深色大图，导航默认用白色文字；
// 其余页面（如新闻详情）为浅色背景，必须使用实底导航。
const DARK_HERO_ROUTES = [
  '/home',
  '/intro',
  '/industry',
  '/systemCert',
  '/cooperationCase',
  '/news',
  '/contact',
]

function Header() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const onDarkHero = DARK_HERO_ROUTES.includes(pathname)
  const solid = scrolled || !onDarkHero

  // 滚动超过一屏后切换为实底
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // 切换路由时重置滚动状态，避免从深色页跳到浅色页后导航配色滞后
  useEffect(() => {
    setScrolled(window.scrollY > 80)
    setMenuOpen(false)
  }, [pathname])

  // 菜单展开时锁定页面滚动
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [menuOpen])

  const onLogo = (e) => {
    e.preventDefault()
    navigate('/home')
  }

  return (
    <header className={['siteHeader', solid ? 'is-solid' : '', menuOpen ? 'is-open' : ''].join(' ')}>
      <div className="mainContent siteHeader__inner">
        <a className="siteHeader__logo" href="/home" onClick={onLogo} aria-label="丰源电力科技 首页">
          <img src={solid ? logoDark : logoLight} alt="丰源电力科技（涿州）有限公司" />
        </a>

        <nav className="siteHeader__nav" aria-label="主导航">
          <ul>
            {MENU.map((item) => (
              <li key={item.href}>
                <NavLink to={item.href} className={({ isActive }) => (isActive ? 'active' : '')}>
                  <span>{item.text}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <button
          className="siteHeader__burger"
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* 移动端展开面板 */}
      <div className="siteHeader__panel" aria-hidden={!menuOpen}>
        <ul>
          {MENU.map((item, i) => (
            <li key={item.href} style={{ transitionDelay: menuOpen ? `${80 + i * 45}ms` : '0ms' }}>
              <NavLink to={item.href} className={({ isActive }) => (isActive ? 'active' : '')}>
                <em>0{i + 1}</em>
                <span>{item.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
        <p className="siteHeader__panelFoot">
          河北省保定市涿州市高官庄镇解家楼村村北
          <br />
          139 1110 2112
        </p>
      </div>
    </header>
  )
}

export default Header